import {OccasionType} from '../../../gql/pwa/graphql.ts';
import styles from '../occasion_details.module.scss';
import {Table} from '../../../components/table/table.tsx';
import {Alignment} from '../../../enums/alignment.ts';
import {TableRow} from '../../../components/table/table_row.tsx';
import {TableCell} from '../../../components/table/table_cell.tsx';
import {__} from '../../../support/lang/translations.ts';

interface OwnProps {
    occasion: OccasionType;
}
export function Environment({occasion}: OwnProps) {
    return (
        <div className={styles.tabs_grid}>
            <Table alignment={Alignment.Start} style={{paddingTop: 0}}>
                <TableRow columns={1}>
                    <TableCell
                        name={__('occasions.details.general_fields.co2_emissions')}
                        value={`${occasion.co2_emissions} g/km`}
                    />
                </TableRow>
                <TableRow columns={1}>
                    <TableCell
                        name={__('occasions.details.general_fields.emission_class')}
                        value={occasion.emission_class ?? '-'}
                    />
                </TableRow>
                <TableRow columns={1}>
                    <TableCell
                        name={__('occasions.details.general_fields.energy_label')}
                        value={occasion.energy_label}
                    />
                </TableRow>
            </Table>
            <Table alignment={Alignment.Start} style={{paddingTop: 0}}>
                <TableRow columns={1}>
                    <TableCell
                        name={__('occasions.details.general_fields.fuel_consumption_average')}
                        value={`${occasion.fuel_consumption_average ?? '-'} / 100km`}
                    />
                </TableRow>
                <TableRow columns={1}>
                    <TableCell
                        name={__('occasions.details.general_fields.fuel_consumption_city')}
                        value={`${occasion.fuel_consumption_city ?? '-'} / 100km`}
                    />
                </TableRow>
                <TableRow columns={1}>
                    <TableCell
                        name={__('occasions.details.general_fields.fuel_consumption_highway')}
                        value={`${occasion.fuel_consumption_highway ?? '-'} / 100km`}
                    />
                </TableRow>
            </Table>
        </div>
    );
}
